import { sha256Text } from './hash.ts';

/**
 * Opak kontomarkering som följer med notiser. Avslöjar varken e-post eller användar-ID, men låter
 * service worker/native avgöra om en notis hör till kontot som är inloggat på enheten just nu.
 */
export function accountTagFor(userId: string): string {
  return sha256Text('autoday-acct|' + userId).slice(0, 16);
}

/**
 * Lokal profil för en autentiserad identitet på en viss serverinstans. Gränsen är server + användar-ID,
 * aldrig visningsnamn eller e-post.
 */
export function accountProfileIdFor(serverOrigin: string, userId: string): string {
  return 'acct_' + sha256Text(serverOrigin.replace(/\/+$/, '') + '|' + userId).slice(0, 20);
}
